<!-- 文章内容 -->
<template>
    <div class="responsibility_c">
      <sub-banner id="id_about">
        <img src="../../assets/images/news/news_top.png"/>
      </sub-banner>
      <div class="tip_d">
          <div class="tip_title">
          <span>{{articleContent.typeName}} </span>
           <span class="detail_small">> &nbsp;
             <!-- {{articleContent.title}} -->
           </span>
           <el-select v-model="articleId" @change="selectArticle">
             <el-option v-for="item in articleAllData" :key="item.id" :label="item.title":value="item.id"></el-option>
           </el-select>
          </div>
      </div>
      <div class="content_article">
          <div class="content_infos">
              <div  v-html="articleContent.content"></div>
          </div>
      </div>
    </div>
</template>

<script>
import { concatMeta } from '@/config/metaJson.js'
import {getArticleInfo,getArticleByTypeList} from '../../service/service';
import SubBanner from "@/components/sub-banner";
export default {
  name: 'responsibility',
  metaInfo () {
    return {
      title: this.pageTitle,
      meta:[{
        name:this.metaName,
        content:this.metaContent,
        keyword:this.keyword,
        description:this.description
      }]
    }
  },
  components: {SubBanner},
  data () {
    return {
      pageTitle: '广州市熵达贸易有限公司-文章内容',
      metaName:'广州市熵达贸易有限公司-文章内容',
      metaContent:'广州市熵达贸易有限公司-文章内容',
      keyword:'广州市熵达贸易有限公司,熵达贸易,熵达',
      description:'广州市熵达贸易有限公司' ,   
      articleContent:{},
      articleAllData:[],
      articleId:0,
    };
  },
  computed: {},
  watch: {
    '$store.state.lang': function (nval, oval) {
      let obj = {
        'en-US': 'Guangzhou entropy Da Trade Co., Ltd',
        'zh-TCC': '廣州市熵達貿易有限公司',
        'zh-CN': '广州市熵达贸易有限公司'
      }
      this.pageTitle = obj[nval]
    }
  },
  methods: {
     async getArticleInfo(id){
         let resp=await getArticleInfo(id);
         if(resp){
             this.articleContent=resp;
             
             this.getArticleByTypeList(this.articleContent.typeId);
         }
     },
     async getArticleByTypeList(typeId){
       let resp=await getArticleByTypeList(typeId,1,9999);
       if(resp){
         this.articleAllData=resp.data;
       }
     },
     selectArticle(item){
       console.log('item',item);
        window.open('/article?id='+item)
       
     }
  },
  created () {

  },
  mounted () {
      let id=this.$route.query.id;
      console.log(id,'id');
      this.articleId=id*1;
      this.getArticleInfo(id);
  },
}
</script>
<style lang='scss' scoped>

.tip_d{
    width:100%;
    background:#f8f8f8;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    .tip_title{
        width:70%;
        margin: auto;
        font-size: 24px;
        font-weight: bold;
        letter-spacing: 0px;
        color: #666666;
        text-align: left;
        .detail_small{
            font-size: 20px;
        }
    }
   

}

 .content_article{
        width:100%;
        background: #ffffff;
        margin-top:45px;
        .content_infos{
            width:70%;
            margin:auto;
            text-align: left;
        }
    }


</style>


<style>
.content_infos img{
  width:100% !important;
  height: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/view/article/index.vue